import React, {Component} from 'react';
//import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import DealerContainer from './DealerContainer';
import OrderbookContainer from './OrderbookContainer';
import TransactionSwitcher from './TransactionSwitcher';
import TotalStats from './TotalStats.js';
import Switcher from '../Charts/Switcher';
 import '../../styles/stylesheets/screen.css';
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import * as firebase from 'firebase';
import {Steps} from 'intro.js-react';
import Link from "react-router-dom/es/Link";
import Button from "./Buttons";
import userStore from '../../stores/UserStore';

let self;
const drawerWidth = "240px";
// const DBwrap = require('../../../../../traderex-backend5/traderex-backend/functions/dbWrap.js');   // didn't work from within frontend (ie. trxprod3/trxprod/...)

const styles = {
  shift: {
    marginLeft: '240px',
    width:'calc(100% - 240px)'
  },
  shiftRight: {
    width:'calc(100% - 240px)'
  },
  shiftBoth: {
    marginLeft: '240px',
    width:'calc(100% - 480px)'
  },
  paper: {
    width: 'auto',
  },
  hide: {
    display: 'inline-block'
  }
};
const style = {
    width: 400,
    margin: 0,
    display: 'inline-block'
};

/**
 * This component acts as the simulationContainer for
 * all components of the simulation receives
 * user prop from app.js
 */
class simulationContainer extends Component {
    constructor(props) {
        console.log("  SimulationContainer constructed.");
        //console.log("  props.dbs[props.location.state.dbi]  is "+JSON.stringify(props.dbs[props.location.state.dbi]) );
        console.log('\n\n');
        super(props);
        this.state = {
            renderplotly: false,
            showingStudents: false,
            showingActivity: false,
            userTransactions: [],
            snackbar: { visible: false, message: '', color: '' },
            studentsData:[],
            open:[],
            isReady: false,
            running: false,
            over: false,
            displayStats: {},
            isSessionAdmin: true,
            showingGodMode: false,
            paused: false,
            pstar: "??"
        };
        this.db = props.dbs[props.location.state.dbi].database().ref(props.institution);
        this.kickUser = this.kickUser.bind(this);
        this.showSnackbar = this.showSnackbar.bind(this);
        this.statListeners = [];
        console.log(props);
        setTimeout( ()=>{
          this.getPendingStudentsData();
        }, 1000);
        self = this;
    }

    /**
     * goes to ref StartSim/Ready and
     * sets the state of renderplotly
     */
    componentDidMount() {
        this.canRender = true;
        this.renderLoop = setInterval(()=>{ this.canRender = true; }, 1000);
        console.log("simulationContainer componentDidMount");
        userStore.setGame(this.props.location.state.sessionid);
        this.plotlyrenderRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child('StartSim').child("Ready");
        this.plotlyrenderRef.on('value', snap => {
            if (!!snap.val() && snap.val() === true) {
                this.setState({
                    renderplotly: true
                });
                this.plotlyrenderRef.off();
            } else {
                this.setState({
                    renderplotly: false
                });
            }
        })

        var timeRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("DisplayTime");
        timeRef.on("value", (ss)=>{
          var data = ss.val();
          if (!!data){
            this.props.updateTime(data);
          }
        });
        this.statListeners.push(timeRef);

        var pstarRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("ImportantData/Simulator/pstar");
        pstarRef.on("value", (ss)=>{
          var data = ss.val();
          this.setState({pstar: data});
        });
        this.statListeners.push(pstarRef);

        var pauseRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("pauser");
        pauseRef.on("value", (ss)=>{
          var data = ss.val();
          this.setState({paused: !!data});
        });
        this.statListeners.push(pauseRef);

        var sessionState = this.db.child("Sessions").child(this.props.location.state.sessionid).child("StartSim").child("running");
        sessionState.on("value", (ss)=>{
          var data = ss.val();
          if (!!data){
            if (Number(data) === 1){
              this.setState({running: true});
            } else {
              this.setState({running: false});
            }
          }
        });
        this.statListeners.push(sessionState);

        var sessionOver = this.db.child("Sessions").child(this.props.location.state.sessionid).child("StartSim").child("State");
        sessionOver.on("value", (ss)=>{
          var data = ss.val();
          if (!!data){
            if (data === "Over"){
              this.setState({over: true});
            } else {
              this.setState({over: false});
            }
          }
        });
        this.statListeners.push(sessionOver);

        this.userTransRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("Users").child(this.props.user.uid).child("Transactions");
        this.userTransRef.on('value', snap => {
            var userdata = snap.val();
            var usertrns = [];
            if (!!userdata) {
                for (var key in userdata) {
                    if (userdata.hasOwnProperty(key)) {
                        usertrns.push(userdata[key]);
                    }
                }
            }
            //console.log(this.state,"User");
            usertrns.reverse();
            this.setState({
                userTransactions: usertrns
            });

            if (this.state.userTransactions.length > 0 && this.state.running) {
              this.showSnackbar(usertrns[0]);
            }
        });

        this.studentRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("UsersPending");

        const godModeDrawer = document.getElementById('godModeDrawer');
        if (godModeDrawer) {
          godModeDrawer.addEventListener('transitionend', () => {
            if(!this.state.over && !this.state.running && !!this.props.location.state.demo === true && !!this.state.showingGodMode === true){
              introJs().setOptions({
                  steps: [
                    {element: '.pause-button', intro: 'This is the Pause Button.  You can pause the simulation here.'},
                    {element: '.step-button', intro: 'Use the Step Button to advance the simulation one step at a time.'},
                    {element: '.thicken-book', intro: 'This is the Thicken Book Button. You can add liquidity to the book here.'},
                    {element: '.thin-book', intro: 'Use the Thin Book Button to make the market less liquid.'},
                    {element: '.increase-p', intro: 'This is the Increase p* Button. Use this to increase the true price of the stock.'},
                    {element: '.decrease-p', intro: 'Use the Decrease p* Button to lower the true price of the stock.'},
                  ],
                    tooltipClass: 'custom-tooltip',
                    overlayOpacity: 0.6
                }).start();
            }
          }, { once: true });
        }
    }

    // showSnackbar(tx) {
    //   const isBuy = (tx.Type || '').toLowerCase() === 'buy';
    //   const color = isBuy ? '#057857' : '#B91C1C';
    //   const message = `${tx.Type} ${tx.Volume} ABC @ ${Number(tx.Price) / 100}`;

    //   this.setState({ snackbar: { visible: true, message, color } });

    //   clearTimeout(this._snackbarTimer);
    //   this._snackbarTimer = setTimeout(() => {
    //     this.setState({ snackbar: { ...this.state.snackbar, visible: false } });
    //   }, 5000);
    // }


    toggleStudents(){
      this.setState({showingStudents: !this.state.showingStudents})
      console.log("student");
    }

    toggleControls(){
      this.setState({showingGodMode: !this.state.showingGodMode})
      console.log(`GodMode: ${this.state.showingGodMode}`);
    }

    pauseMe(){
      var pauseRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("pauser");
      pauseRef.set(!this.state.paused);
    }
     stepMe(){
      var stepRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("stepper");
      stepRef.set(true);
    }
    pstarDown(){
      console.log("pstar-down")
      let newPstar = parseFloat(this.state.pstar) - .5;
      let pstarRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("ImportantData/Simulator/pstar");
      pstarRef.set(newPstar || "20");
      console.log('i just set it to new pstar  ',newPstar);
      this.setState({pstar: newPstar || "20"});
    }
    pstarUp(){
      console.log("pstar-up")
      let newPstar = parseFloat(this.state.pstar)  + .5;
      let pstarRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("ImportantData/Simulator/pstar");
      pstarRef.set(newPstar || "20");
      this.setState({pstar: newPstar || "20"});
    }
    thinBook(){
      console.log("thin book");
      // set to a large random number;  if it changes, we thinBook() (multiply robot order amounts by half) elsewhere in the code   -Nathan Bendich;  August 1, 2022
      var thinBookClickedRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("lastThinBookClickedNumber").set(Math.floor(Math.random()*1000000000 ));
      /*
      var rand=Math.floor(Math.random()*1000000000 ); // technically we should make absolutely sure this value **__CHANGES__**, but 
      //alert("Thin Book clicked.  rand is "+rand);
      var rand=Math.floor(Math.random()*1000000000 ); // technically we should make absolutely sure this value **__CHANGES__**, but 
      thinBookClickedRef.set(   rand  );
      */
    }
    thickenBook(){
      console.log("thicken");
      var thickenBookClickedRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("lastThickenBookClickedNumber").set(Math.floor(Math.random()*1000000000 ));
    }
    passPoint(newpt){
      /*
      self.setState({
          pstar: newpt.pstar || "20"
      });
      */
      //console.log("why is this here? -")
    }

    registerStats(key){
      let userStatRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("Users").child(key).child("Assets").child("INTC").child("Stats");
      let mRef = userStatRef.child("Mission");
      mRef.on("value", ss=>{
        let data = ss.val();
        if (!!data){
          let displayStats = Object.assign({}, this.state.displayStats);    //creating copy of stats
          displayStats[key].mission = data;
          this.setState({displayStats});
        }
      });
      this.statListeners.push(mRef);
      let sRef = userStatRef.child("Shares");
      sRef.on("value", ss=>{
        let data = ss.val();
        if (!!data){
          let displayStats = Object.assign({}, this.state.displayStats);    //creating copy of stats
          displayStats[key].shares = data;
          this.setState({displayStats});
        }
      });
      this.statListeners.push(sRef);
      console.log("student data", this.props.location.state)
      if(!this.state.over && !this.state.running && !!this.props.location.state.demo === true){
            introJs().setOptions({
                steps: [
                  {element: '.order-book-container-div-style', intro: 'This is the Order Book.  You can place orders here.'},
                  {element: '.center', intro: 'Use the center button to center your view on the current price.'},
                  {element: '.graph-div', intro: 'This is the graph of the stock price.  It updates in real-time.'},
                  {element: '.simulation-log', intro: 'This is the Transaction Log.  It shows all the transactions that have occurred.'},
                  {element: '.total-stats-div-style', intro: 'These are the Total Stats of the simulation, updating live as you play!'},
                  {element: '.mission', intro: 'This is your goal. Depending on the mission, you will have to buy or sell a certain amount of shares, and beat the Market VWAP.'},
                  {element: '.toggle-controls', intro: 'With the controls button, you can change simulation parameters like p* and book thickness mid-game, as well as pause or step through the simulation.'},
                  {element: '.participants', intro: 'This is the Participants Button. It shows the list of participants in the simulation, and allows you to remove participants.'},
                  {element: '.start-button', intro: 'This is the Start Button. You can start the simulation here.'}
                ],
                  tooltipClass: 'custom-tooltip',
                  overlayOpacity: 0.6
              }).start();
      }
          
    }

    // snackbar.js
showSnackbar(tx) {
  if (this.props.location.state.dealerMode) return;

  const isBuy = (tx.Type || '').toLowerCase() === 'buy';
  const color = isBuy ? '#057857' : '#B91C1C';
  const message = `${tx.Type} ${tx.Volume} ABC @ ${Number(tx.Price) / 100}`;

  // Create snackbar container
  const snackbar = document.createElement("div");
  Object.assign(snackbar.style, {
    position: "fixed",
    top: "20%",
    left: "0",
    padding: "8px 16px",
    borderRadius: "8px",
    boxShadow: "0 4px 6px rgba(0,0,0,0.3)",
    color: "white",
    display: "flex",
    alignItems: "center",
    minWidth: "200px",
    height: "50px",
    transform: "translateX(-100%)",
    transition: "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
    zIndex: 9999,
    opacity: "0",
  });

  // Add color bar
  const bar = document.createElement("div");
  Object.assign(bar.style, {
    width: "6px",
    height: "100%",
    backgroundColor: color,
    borderRadius: "3px",
    marginRight: "10px",
  });
  snackbar.appendChild(bar);

  // Add text
  const text = document.createElement("span");
  text.innerText = message;
  snackbar.appendChild(text);

  document.body.appendChild(snackbar);

  // Trigger animation in
  requestAnimationFrame(() => {
    snackbar.style.transform = "translateX(0)";
    snackbar.style.opacity = "1";
  });

  // Hide after 5s
  setTimeout(() => {
    snackbar.style.transform = "translateX(-100%)";
    snackbar.style.opacity = "0";

    // Remove from DOM after transition
    setTimeout(() => snackbar.remove(), 300);
  }, 5000);
}


    getPendingStudentsData() {
        // this.setState({
        //     studentsData:[]
        // })

        this.studentRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("UsersPending");
        //this.userRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("Users").child(this.props.uid).child("INTC").child("stats");
        this.studentRef.on('value', snap =>{
          let rawData = snap.val();
          //console.log("data of student " + rawData);
          let studentInfo;
          let students = [];
          let openstate = [];
          let displayStats = this.state.displayStats;
          for(var key in rawData){
            if (rawData[key].displayName){
                students.push(rawData[key]); //has .uid which == key too
                if (!displayStats.hasOwnProperty(key)){
                  displayStats[key] = {displayName: rawData[key].displayName, mission: "-", shares: "-"};
                  let that = this;
                  let uid = key;
                  setTimeout( ()=>{
                      that.registerStats(uid);
                  }, 0);
                }
            }
          }
          var len = students.length;
          for (var i=0;i<len;i++){
              var flag = false;
              openstate.push(flag);
          }
          this.setState({
              studentsData: students,
              openBuy: openstate,
              displayStats: displayStats
          });
          console.log("student data ", this.state.studentsData);
         // this.state.dataItemsSell = this.state.studentsDataSell.map((numbersSell) =><div>{numbersSell}</div>);
         // this.state.dataItemsBuy = this.state.studentsDataBuy.map((numbersBuy) =><li>{numbersBuy}</li>);
      })
    }

    startTutorial() {
        //console.log("simulationContainer startTutorial");
        this.setState({
            stepsEnabled: true
        })
    }

    handleStart() {
      this.setState({isReady: true});
    }

    handleClickBuy(index) {
        console.log("student clicked", this.state.open);
        var test = this.state.open;
        if(test[index]===false){
            test[index] = true;
        }
        else {
            test[index] = false;
        }
        //test[index] = !test[index];
        this.setState({open: test})

    }

    /**
     * will remove a human dealer from the game
     */

    kickUser(uid, name){
        let userRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("Users").child(uid).child("didUserLeave");
        userRef.set({ "didUserLeave": true });
        // alert('KICKED ' + uid);
        alert('You have removed ' + name);
    }

    componentWillReceiveProps(nextProps, nextState){
      console.log(nextProps, nextState);
    }

    componentWillUnmount() {
        // console.log("simulationContainer componentWillUnmount");
        this.plotlyrenderRef.off();
        this.studentRef.off();
        this.statListeners.map(theRef=>{
          theRef.off();
        });
        this.props.updateTime(false);
    }

    shouldComponentUpdate(){
      if (this.canRender){
        this.canRender = false;
        return true;
      }
      return false;
    }
    /**
     * renders all components of the simulation here
     * based on renderplotly(bool) conditionally render plotly graph
     */
    render() {
        console.log("simulationContainer render");
        let {stepsEnabled, steps, initialStep} = this.state;
        // alert(this.props.location.state.creator);
        return (
          <div className="app-sim">
                      {/* God Mode Drawer as a sliding div using inline styles */}
                      <div id='godModeDrawer'
                        style={{
                          position: 'fixed',
                          top: 0,
                          right: 0,
                          height: '100%',
                          width: '240px',
                          background: '#1a202c',
                          color: 'white',
                          boxShadow: '0 0 10px rgba(0,0,0,0.5)',
                          transition: 'transform 0.3s',
                          zIndex: 50,
                          transform: this.state.showingGodMode ? 'translateX(0)' : 'translateX(100%)',
                          display: 'block'
                        }}
                      >
                      <div>
                      <ul style={{ marginLeft: "auto", marginRight: "auto", width: "15rem", "list-style-type": "none"}}>
                        <li className='controls-panel-button' style={{"list-style": "none", "display": "list-item"}}>
                          <button className='button-default pause-button' onClick={this.pauseMe.bind(this)}>
                            {this.state.paused && <span>Unpause</span>}
                            {!this.state.paused && <span>Pause</span>}
                          </button>
                        </li>
                        { !!this.props.location.state.demo &&
                        <li className='controls-panel-button'>
                          <button className='button-default step-button' onClick={this.stepMe.bind(this)}>
                            <span>Step</span>
                          </button>
                        </li>
                         }
                        <li className='controls-panel-button'>
                          <button className='button-default thicken-book' onClick={this.thickenBook.bind(this)}>
                            <span>Thicken Book</span>
                          </button>
                        </li>
                        <li className='controls-panel-button'>
                          <button className='button-default thin-book' onClick={this.thinBook.bind(this)}>
                            <span>Thin Book</span>
                          </button>
                        </li>
                        <li className='controls-panel-button'>
                          <h4>Current p*: {this.state.pstar}</h4>
                        </li>
                        <li className='controls-panel-button'>
                          <button className='button-default increase-p' onClick={this.pstarUp.bind(this)}>
                            <span>Increase p*</span>
                          </button>
                        </li>
                        <li className='controls-panel-button'>
                          <button className='button-default decrease-p' onClick={this.pstarDown.bind(this)}>
                            <span>Decrease p*</span>
                          </button>
                        </li>
                      </ul>
                      </div>
                      </div>
                      <div
                        id="activityDrawer"
                        style={{
                          position: 'fixed',
                          top: 0,
                          right: this.state.showingGodMode ? `240px` : 0,
                          height: '100%',
                          width: `240px`,
                          background: '#1A202C',
                          color: 'white',
                          boxShadow: '0 0 10px rgba(0,0,0,0.5)',
                          transition: 'transform 0.3s, right 0.3s', // animate both
                          zIndex: 45, // under God Mode if they overlap
                          transform: this.state.showingActivity ? 'translateX(0)' : 'translateX(100%)',
                          display: 'flex',
                          flexDirection: 'column',
                          overflow: 'hidden'
                        }}
                      >
                        {/* Header */}
                        <div className="activity-log">
                          <h4>Activity</h4>                          
                        </div>

                        {/* Activity List */}
                        <div
                        style={{
                          flex: 1,               // take up remaining space
                          overflowY: 'auto',     // enable scrolling
                        }}>
                          {/* <p>{JSON.stringify(this.state.userTransactions)}</p> */}
                          {this.state.userTransactions.map((t, idx) => {
                          const symbol = "ABC" //t.AssetId || "-";
                          const side = (t.Type || "").toLowerCase(); // "buy" | "sell"
                          const isBuy = side === "buy";
                          const qty = (t.Volume !== undefined && t.Volume !== null) ? t.Volume : 0;

                          // assume cents -> dollars
                          const numPrice = Number(t.Price);
                          const priceDisplay = Number.isFinite(numPrice)
                            ? (numPrice / 100).toFixed(2)
                            : t.Price;

                          const timeStr = t.Time
                            ? new Date(t.Time).toLocaleString(undefined, {
                                month: "short",
                                day: "numeric",
                                hour: "numeric",
                                minute: "2-digit"
                              })
                            : "";

                          return (
                            <div
                              key={idx}
                              className="activity-log"
                            >
                              {/* Row 1: Symbol + Time */}
                              <div className="activity-log-item">
                                <span style={{"font-weight": 700 }}>{symbol}</span>
                                <span style={{ color: "#CBD5E0"}}>{timeStr}</span>
                              </div>

                              {/* Row 2: Fill + side */}
                              <div className="activity-log-item">
                                <span style={{ color: isBuy ? "#4ade80" : "#f87171" }}>
                                  FILL ${priceDisplay} {isBuy ? "BUY" : "SELL"}
                                </span>
                                {/* no orderType in your data; hide or hardcode if you want */}
                                <span className="text-gray-400">MKT</span>
                              </div>

                              {/* Row 3: Details we actually have */}
                              <div className="activity-log-item-gray">
                                <span>Qty: {qty}</span>
                                {/* placeholders to keep the grid feel; remove if not needed */}
                                <span>&nbsp;</span>
                                <span>&nbsp;</span>
                                <span>&nbsp;</span>
                                <span>&nbsp;</span>
                              </div>
                            </div>
                          );
                        })}
                        </div>
                      </div>
                <div
                  style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    height: '100%',
                    width: '240px',
                    background: '#1a202c',
                    color: 'white',
                    boxShadow: '0 0 10px rgba(0,0,0,0.5)',
                    transition: 'transform 0.3s',
                    zIndex: 50,
                    transform: this.state.showingStudents ? 'translateX(0)' : 'translateX(-100%)',
                    display: 'block'
                  }}
                >
            {/* <Drawer variant="persistent" style={Object.assign({}, !this.state.showingStudents && styles.hide)} open={this.state.showingStudents} onClose={this.toggleStudents.bind(this)}> */}
                {/* <div style={styles.paper}>{this.state.studentsData}</div> */}
                <div>
                <ul style={{
                    width:'240px',
                    margin: '0 auto',
                }} >
                    {this.state.studentsData.map((student,index)=>{ return (
                       <li className={(this.props.location.state.dealerMode == true && Math.abs(parseInt(this.state.displayStats[student.uid].shares) )> 500 ? "overLimit" : "underLimit" )} key={student.displayName} style={{ display: 'flex', alignItems: 'center', gap: '1rem', padding: '1rem' }} button>
                          <h4>{index + 1}</h4>
                          <h4>{student.displayName}</h4>
                          <h4>{this.state.displayStats[student.uid].shares}</h4>
                            {((this.props.location.state.solo || (this.props.user.uid != this.props.location.state.creator)) || !this.props.location.state.dealerMode)
                        ?
                        <div></div>
                        :
                        <button onClick={()=>{this.kickUser(student.uid, student.displayName)}}>x</button>
                    }

                            {!this.props.location.state.dealerMode && <h4>{this.state.displayStats[student.uid].mission}</h4>}
                        </li>
                         );
                    })
                    }
                    </ul>
                    {/* <List >
                        <ListItem button onClick={this.handleClickBuy.bind(this)}>
                            <ListItemText inset primary="Buy" />
                            {this.state.openBuy ? <ExpandLess /> : <ExpandMore />}
                        </ListItem>
                        <Collapse in={this.state.openBuy} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                <ListItem>
                                <ListItemText inset primary={this.state.dataItemsBuy} />
                                </ListItem>
                            </List>
                        </Collapse>
                        <ListItem button onClick={this.handleClickSell.bind(this)}>
                            <ListItemText inset primary="Sell" />
                            {this.state.openSell ? <ExpandLess /> : <ExpandMore />}
                        </ListItem>
                        <Collapse in={this.state.openSell} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                <ListItem>
                                <ListItemText inset primary={this.state.dataItemsSell} />
                                </ListItem>
                            </List>
                        </Collapse>
                    </List> */}
                </div>
            </div>
            <div className="simulation-container-style" style={Object.assign(Object.assign(Object.assign({}, this.state.showingGodMode && styles.shiftRight), this.state.showingStudents && styles.shift), this.state.showingStudents && this.state.showingGodMode && styles.shiftBoth)}>
              {/* Snackbar */}
              {/*<div
                style={{
                  position: 'fixed',
                  top: '20%',
                  left: '0px',
                  padding: '8px 16px',
                  borderRadius: '8px',
                  boxShadow: '0 4px 6px rgba(0,0,0,0.3)',
                  color: 'white',
                  display: 'flex',
                  minWidth: '200px',
                  height: '50px',
                  transform: this.state.snackbar.visible ? 'translateX(0)' : 'translateX(-100%)',
                  transition: 'transform 0.3s ease-in-out, opacity 0.3s ease-in-out',
                  zIndex: 9999
                }}
              >
              <div
                style={{
                width: '6px',
                height: '100%',
                backgroundColor: this.state.snackbar.color,
                borderRadius: '3px',
                marginRight: '10px'
              }}
              ></div>
                  
                {this.state.snackbar.message}
              </div> */}
              
              <button
                onClick={() =>  this.setState({ showingActivity: !this.state.showingActivity })}
                style={{
                  position: 'fixed',
                  top: '20%',
                  right: this.state.showingGodMode
                    ? `240px` // shift left if God Mode is open
                    : '0px',               // default 10px from screen edge
                  transform: 'translateY(-50%)',
                  zIndex: 100, // above drawers
                  background: '#3182CE',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px 0 0 8px',
                  padding: '10px 14px',
                  cursor: 'pointer',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                  transition: 'right 0.3s'
                }}
              >
                {this.state.showingActivity ? 'Close' : 'Activity'}
              </button>
              <div className='simulation-options-stats-div'>
                <div className="simulation-options-div">
                    <Button
                        uid={this.props.user.uid}
                        institution={this.props.institution}
                        sessionid={this.props.location.state.sessionid}
                        db={this.db}
                        isReady={this.state.isReady}
                        dealerMode={this.props.location.state.dealerMode}
                        toggleControls ={this.toggleControls.bind(this)}
                    />
                    <button 
                      onClick={this.toggleStudents.bind(this)} 
                      className='participants button-default'>
                        {this.state.showingStudents ? <span>Hide</span> : <span>Show</span>} Participants 
                    </button>
                </div>


                <div className="total-stats-div-style simulation-box">
                    <TotalStats
                        institution={this.props.institution}
                        sessionid={this.props.location.state.sessionid}
                        db={this.db}
                        uid={this.props.user.uid}
                        dealerMode={this.props.location.state.dealerMode}
                    />
                </div>
              </div>
                  <div style={{display: "flex" }}>
                    <div className="order-book-container-div-style simulation-box">
                       {!!this.props.location.state.dealerMode &&
                          <DealerContainer
                              institution={this.props.institution}
                              sessionid={this.props.location.state.sessionid}
                              db={this.db}
                              uid={this.props.user.uid}
                              onReady={this.handleStart.bind(this)}
                              solo = {this.props.location.state.solo}
                              creator = {this.props.location.state.creator}
                          />
                        }
                        {!this.props.location.state.dealerMode &&
                          <OrderbookContainer
                              institution={this.props.institution}
                              sessionid={this.props.location.state.sessionid}
                              db={this.db}
                              uid={this.props.user.uid}
                              onReady={this.handleStart.bind(this)}
                          />
                        }
                    </div>
                <div className="simulation-container-right">
                <div className="graph-div simulation-box">
                    {this.state.renderplotly
                        ?
                        <Switcher
                            institution={this.props.institution}
                            db={this.db}
                            sessionid={this.props.location.state.sessionid}
                            passPoint={this.passPoint}
                        />
                        :
                        <div>
                            Loading 3
                            Day Sim...
                        </div>
                    }
                </div>

                <div className="simulation-log simulation-box">
                    <TransactionSwitcher
                        institution={this.props.institution}
                        sessionid={this.props.location.state.sessionid}
                        db={this.db}
                        uid={this.props.user.uid}
                    />
                </div>
                </div>
                </div>
            </div>
          </div>
        );
    }
}

simulationContainer.propTypes = {
    authed: PropTypes.bool,
    user: PropTypes.object,
    sessionid: PropTypes.string
};

export default simulationContainer;



// WEBPACK FOOTER //
// ./src/components/Orderbook/SimulationContainer.js